import React, { forwardRef, useContext } from 'react';
import { Link, useLocation } from "react-router-dom";
import { FAVOURITES_ROUTE, GLOBAL_REVIEWS_ROUTE, MAIN_ROUTE } from "../../../../utils/consts";
import { observer } from "mobx-react-lite";

import logo from "../../../../Assets/21.png";
import chatIcon from "../../../../Assets/BottomMenu/chatIcon.svg";
import Favourites from "../../../../Assets/hearts/heart-black.svg";

import styles from './NavBar.module.css';

import { reachGoal } from "../../../../utils/metrika/metrika";
import UserMiniProfile from "../../../profile/UserMiniProfile/UserMiniProfile";
import { Context } from "../../../../index";

import {
    getMessagesTargetRoute,
    isMessagesRoute,
    formatMessagesBadge
} from "../../../../utils/chat/messagesNavigation";

const NavBar = observer(forwardRef((props, ref) => {
    const { messages, user } = useContext(Context);
    const location = useLocation();

    const isFavouritesPage = location.pathname.startsWith(FAVOURITES_ROUTE);
    const isReviewsPage = location.pathname.startsWith(GLOBAL_REVIEWS_ROUTE);
    const isChatPage = isMessagesRoute(location.pathname);

    const totalUnreadCount = messages.totalUnreadCount;
    const messagesRoute = getMessagesTargetRoute();

    return (
        <div
            className={`${styles.navBarWrapper} ${isFavouritesPage ? styles.favouritesPageMod : ''}`}
            ref={ref}
        >
            <div className="container-custom">
                <div className={styles.navBarContent}>
                    <div className={styles.navBarLogo}>
                        <Link
                            to={MAIN_ROUTE}
                            onClick={() => reachGoal("history.push(MAIN_ROUTE) LOGO")}
                            className={styles.logoButton}
                            aria-label="Перейти на главную страницу Arento"
                        >
                            <img
                                alt="Логотип Arento"
                                src={logo}
                                className={styles.logoImage}
                            />
                        </Link>
                    </div>

                    <div
                        className={styles.userActions}
                        data-prerender-remove="true"
                    >
                        {!user.isAuth && (
                            <>
                                <Link
                                    to={messagesRoute}
                                    className={`${styles.actionButton} ${isChatPage ? styles.actionButtonActive : ''} ${styles.mobileHide}`}
                                    onClick={() => reachGoal("history.push(MESSAGES_ROUTE) NAVIGATION")}
                                    title="Сообщения"
                                    aria-label="Сообщения"
                                >
                                    <img
                                        src={chatIcon}
                                        alt="Сообщения"
                                        height={30}
                                        className={styles.actionIcon}
                                        style={{ padding: "2px" }}
                                    />

                                    {totalUnreadCount > 0 && (
                                        <div className={styles.badge}>
                                            {formatMessagesBadge(totalUnreadCount)}
                                        </div>
                                    )}
                                </Link>

                                <Link
                                    to={FAVOURITES_ROUTE}
                                    className={`${styles.actionButton} ${isFavouritesPage ? styles.actionButtonActive : ''} ${styles.mobileHide}`}
                                    onClick={() => reachGoal("history.push(FAVOURITES_ROUTE) NAVIGATION")}
                                    title="Избранное"
                                    aria-label="Избранное"
                                >
                                    <img
                                        src={Favourites}
                                        alt="Избранное"
                                        className={styles.actionIcon}
                                    />
                                </Link>
                            </>
                        )}

                        <Link
                            to={GLOBAL_REVIEWS_ROUTE}
                            className={`${styles.reviewButton} ${isReviewsPage ? styles.reviewButtonActive : ''}`}
                            onClick={() => reachGoal("history.push(GLOBAL_REVIEWS_ROUTE)")}
                            aria-label="Отзывы гостей"
                            title="Отзывы гостей"
                        >
                            <span>Отзывы</span>
                        </Link>

                        <UserMiniProfile />
                    </div>
                </div>
            </div>
        </div>
    );
}));

export default NavBar;